module.exports = "data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAHgAAAB4BAMAAADLSivhAAAAIVBMVEUAAABQrf9V//9Prf9PrP9PrP9OrP/L5f3g8P+83P7V6v/MKYvnAAAABnRSTlMAdgPMv/PV3cPlAAAA0ElEQVRYw+3YPQrCQBAF4FUx50iOYOEFLDyHQRx/DmCws5LgAQx2VhI8pVmInaPDrOKseY8QFsKXYTNThHUIIg+JYwuvz6KcgD+BZ06UxBheFqJs/wtXRbV7dwVWNtZnDEk0ONIh2dzYXPyr2/UVWIn5VvFPE2N4VbLZe9yuD1/BdXl8dpNg1j5w7aOuHL5nY32Od0g6hyMdklc4ozzV4v6UaKLFPSLKtXjQ4LkWDxu8CK2s3/NPvrbLxqPU6N8QMDAwMDAwcCg2drIuxwgizh2saMw5ZKWMMgAAAABJRU5ErkJggg=="


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/home/sub/75.png
// module id = 841
// module chunks = 1